         
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row style="width:100%">
                <sw-inputs
                  inputTabla="users"
                  inputCampo="name"
                  >
                </sw-inputs>
                <sw-inputs
                  inputTabla="users"
                  inputCampo="email"
                  >
                </sw-inputs>
                <sw-inputs
                  inputTabla="users"
                  inputCampo="password"
                  >
                </sw-inputs>
                <b-col :md="12" :lg="12" v-for="(items,index) in permisosArray" :key="'arrayPermisos'+index" >
                  <h5  class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Permisos módulo {{items.modulos}}</h5>
                  <b-form-checkbox
                      style="display:inline-block;margin: 5px 10px"
                      v-for="(items2,index2) in items.permisos" :key="'arrayModulos'+index2"
                      v-model="dataForm[namePath].users.permisos_modulos[items.modulos][items2]"
                      name="checkbox-1"
                    >
                    {{items2}}
                  </b-form-checkbox>
                </b-col>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="indexData"
            nameBtn="Usuario"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  data(){
    return {
      permisosArray: [ ]
    }
  },
  props: {
  },
  async created(){
    if(this.indexData!==false)
    {
      await this.updateDataForm({data: this.dataGet[this.namePath].data[this.indexData]})
   }  
    else{
      await this.updateDataForm({state: 'users/permisos_modulos', data: this.permisosModulos})      
    }  
    let permisosArray = []
      let datapermisosArray = Object.keys(this.permisosModulos)
      for (let i = 0; i < datapermisosArray.length; i++) {
        this.permisosArray[i]={ modulos: '', permisos: []}
        this.permisosArray[i].modulos=datapermisosArray[i]  

        permisosArray = Object.keys(this.permisosModulos[datapermisosArray[i]])  
        for (let j = 0; j < permisosArray.length; j++) {

          this.permisosArray[i].permisos.push(permisosArray[j])          
        }    
      }
  },
  async destroy()
  {
    await this.resetGlobal({state: 'indexData'})
  },
	computed: {
		...mapState({ 
			permisosModulos   : state => state.configStore.permisosModulos,
		})
	},
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'usuarioNuevoFtn' })
    }
  }
}
</script>
<style>
</style>